



import Vue from 'vue'
import {
  initialize,
  saveUserId,
  saveContactId,
  saveFeatureFlag
} from '@/services'
import { fetchCat } from '@/helper/permission.helper'
import LoginService from '../services/LoginService'
export default Vue.extend({
  beforeMount() {
    try {
      const { locationId, userId, contactId, featureFlag } = fetchCat()

      if (locationId) {
        initialize(locationId)
      }

      if (userId) {
        saveUserId(userId)
      }

      if (contactId) {
        saveContactId(contactId)
      }

      if (featureFlag) {
        saveFeatureFlag(featureFlag)
      }
    } catch (error) {
      this.$router.push({ path: '/login' })
    }
  },
  mounted() {
    this.fetchUserAvatar()
  },
  methods: {
    async fetchUserAvatar() {
      try {
        const avatar = await LoginService.getAvatar()
        this.$store.commit('SAVE_AVATAR', avatar)
      } catch (error) {
        console.error('Error while fetching user avatar --> ', error)
      }
    }
  }
})
